// This is to avoid circular dependencies with reselect of the selectors.
// It is normal to have circular dependencies in selector (https://github.com/reduxjs/reselect/issues/169#issuecomment-381686600)
// and this is more a problem of combining webpack and reselect: https://github.com/reduxjs/reselect/issues/169#issuecomment-246212998

export const getById = ({
  plans
}) => plans.byId;
export default {
  getById
};